import { set, when } from 'cerebral/operators'
import { state } from 'cerebral/tags'
import deselectAllFiles from 'modules/Media/chains/deselectAllFiles'
import selectTreeNodes from 'modules/Node/actions/selectTreeNodes'
import loadDefaultFiles from 'modules/Media/chains/loadDefaultFiles'

export default [
  set(state`startPage.startIndex`, 0),
  ...deselectAllFiles,
  set(state`media.sortType`, 'LATEST'),
  set(state`app.showSort`, false),
  when(state`startPage.latest`),
  {
    false: [
      ...loadDefaultFiles,
      selectTreeNodes, // since path is not passed it will deselect last node
      set(state`node.selectedNode.id`, null),
      set(state`node.selectedNode.path`, null),
      set(state`node.rebuildTree`, true),
      set(state`startPage.latest`, true)
    ],
    true: []
  },
  when(state`startPage.show`),
  {
    true: [
      set(state`app.currentView`, 'startpage'),
      set(state`node.showMenuToggle`, false),
      set(state`node.panel.show`, false)
    ],
    false: [
      set(state`app.currentView`, 'media'),
      set(state`node.showMenuToggle`, true)
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/App/chains/onLogoClicked.js